import { ERROR_ACCESS_TOKEN_HAS_EXPIRED } from '@constants/error-codes/global';
import { RequestError } from '@utils/request/request.type';

export const showToastErrorRequest = (error?: RequestError) => {
  return error && error.code !== ERROR_ACCESS_TOKEN_HAS_EXPIRED && error.status !== 401;
};
